import { useEffect, useState } from 'preact/hooks';
import { hubspotApi } from '@/api/hubspot';
export function useHubSpotDealAnalytics(companyId) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    useEffect(() => {
        if (!companyId)
            return;
        let cancelled = false;
        const load = async () => {
            setLoading(true);
            setError(null);
            const resp = await hubspotApi.getDealAnalytics(companyId);
            if (!cancelled) {
                if (resp.error)
                    setError(resp.error);
                else
                    setData(resp.data || null);
                setLoading(false);
            }
        };
        load();
        return () => { cancelled = true; };
    }, [companyId]);
    return { data, loading, error };
}
